<template>
  <edit-modal
    caption="Nieuwe kolom"
    :isActive="isActive">
    <div class="field">
      <label for="type">Type</label>
      <div class="control">
        <div class="select">
          <select v-model="column.type_id">
            <option v-for="type in types" :key="type.id" :value="type.id">{{ type.name }}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="field">
      <label for="name">Tabnaam</label>
      <div class="control">
        <input type="text" name="name" v-model="column.tabname" class="input">
      </div>
    </div>

    <div class="field">
      <label for="name">Kolomnaam</label>
      <div class="control">
        <input type="text" name="name" v-model="column.name" class="input">
      </div>
    </div>

    <div class="field">
      <save-buttons
        :disabled="!valid"
        @save="save"
        @cancel="close">
      </save-buttons>
    </div>
  </edit-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import EditModal from '@/components/modules/EditModal'
import SaveButtons from '@/components/modules/SaveButtons'

export default {
  props: [
    'isActive'
  ],
  components: {
    EditModal,
    SaveButtons
  },
  data () {
    return {
      column: {}
    }
  },
  computed: {
    ...mapGetters({
      types: 'types/types'
    }),
    valid () {
      if (this.column.name && this.column.type_id && this.column.tabname) return true

      return false
    }
  },
  methods: {
    save () {
      this.$store.dispatch('columns/save', this.column)

      this.clear()
      this.close()
    },
    clear () {
      this.column = {}
    },
    close () {
      this.clear()
      this.$emit('close')
    }
  }
}
</script>
